const PartOfTheDay = Object.freeze({
  EARLY_MORNING: 'early_morning',
  MORNING: 'morning',
  LATE_MORNING: 'late_morning',
  EARLY_AFTERNOON: 'early_afternoon',
  AFTERNOON: 'afternoon',
  LATE_AFTERNOON: 'late_afternoon',
  EARLY_EVENING: 'early_evening',
  EVENING: 'evening',
  LATE_EVENING: 'late_evening',
} as const);

export type PartOfTheDay = (typeof PartOfTheDay)[keyof typeof PartOfTheDay];
export const allPartOfTheDay: [PartOfTheDay, ...PartOfTheDay[]] = Object.values(PartOfTheDay) as [
  PartOfTheDay,
  ...PartOfTheDay[],
];

export default PartOfTheDay;
